import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const LandingPage = () => {
  const { language } = useLanguage();
  const bn = language === "bn";

  return (
    <div className="relative mx-auto min-h-screen w-full max-w-md overflow-hidden bg-[#fbfaf7] px-5 text-center">
      <main className="relative z-10 flex min-h-screen w-full flex-col items-center pt-[27vh]">
        <motion.img
          src="/logo.png"
          alt="Sebaco"
          className="mb-4 h-24 w-24 object-contain"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
        />
        <motion.h1
          className="font-serif text-[3.5rem] font-extrabold leading-none tracking-tight text-[#18544e]"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Sebaco
        </motion.h1>
        <motion.p
          className="mt-3 max-w-sm text-base font-medium leading-7 text-[#5d6f6b]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15 }}
        >
          {bn ? "স্মার্ট এক্সিকিউশন। বেটার ক্লিনিক্যাল আউটকাম।" : "Smart Execution. Better Clinical Outcome."}
        </motion.p>
        <motion.div
          className="mt-9"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Link to="/signup">
            <motion.button
              className="flex min-w-[190px] items-center justify-center gap-3 rounded-full bg-[#2c8880] px-8 py-4 text-base font-extrabold text-white"
              whileTap={{ scale: 0.97 }}
            >
              {bn ? "যোগ দিন" : "Join Now"}
              <ArrowRight className="h-5 w-5" />
            </motion.button>
          </Link>
        </motion.div>
      </main>
      <img
        src="/landing-clinic-trimmed.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-1/2 z-0 w-[115%] max-w-none -translate-x-1/2 object-contain"
      />
    </div>
  );
};

export default LandingPage;
